import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {
  filteredMembers= [
    {
      "SNo": 1,
      "MM_YY": "Jan/25",
      "DecorsBill_A": "₹84000",
      "PackagesBill_B": "₹4535000",
      "TotalBusiness_C": "₹4619000",
      "FranchiseShare": 230950,
      "PBShare": 461900,
      "SettledOn": "02.02.2025",
      "Approval": "PB/DIRECTOR"
    },
    {
      "SNo": 2,
      "MM_YY": "Feb/25",
      "DecorsBill_A": "₹73260",
      "PackagesBill_B": "₹5345000",
      "TotalBusiness_C": "₹5418260",
      "FranchiseShare": 270913,
      "PBShare": 541826,
      "SettledOn": "03.03.2025",
      "Approval": "PB/DIRECTOR"
    },
    {
      "SNo": 3,
      "MM_YY": "Mar/25",
      "DecorsBill_A": "₹65300",
      "PackagesBill_B": "₹6315000",
      "TotalBusiness_C": "₹6380300",
      "FranchiseShare": 319015,
      "PBShare": 638030,
      "SettledOn": "02.04.2025",
      "Approval": "PB/DIRECTOR"
    },
    {
      "SNo": 4,
      "MM_YY": "Apr/25",
      "DecorsBill_A": "₹87420",
      "PackagesBill_B": "₹7262000",
      "TotalBusiness_C": "₹7349420",
      "FranchiseShare": 367471,
      "PBShare": 734942,
      "SettledOn": "02.05.2025",
      "Approval": "PB/DIRECTOR"
    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
